import { Image as BaseImage, Text as BaseText } from '@react-pdf/renderer';
import React from 'react';
import useProduct from '../useProduct';
import { Box, Flex } from '../..';
import CircleIcon from '../../CircleIcon';

const baseUrl =
  'https://res.cloudinary.com/bottlebooks/image/upload/v1652017614/pdf-objects/pdf-design-system/Product/Certifications';
const certificationImages = {
  // de_bioland,
  // za_bee,
  // za_bwi,
  // za_ipw,
  // za_wwf_bwi_champion,
  // za_oldVinesProject,
  // za_wieta,
  us_ccsw: `${baseUrl}/us_ccsw.png`,
  us_lodi: `${baseUrl}/us_lodi.png`,
  us_napa_green: `${baseUrl}/us_napa_green.png`,
  us_sip: `${baseUrl}/us_sip.png`,
  us_california_green: `${baseUrl}/us_california_green.png`,
  us_fish_friendly: `${baseUrl}/us_fish_friendly.png`,
  us_ccof_organic: `${baseUrl}/us_ccof_organic.png`,
  us_live: `${baseUrl}/us_live.png`,
  us_salmon_safe: `${baseUrl}/us_salmon_safe.png`,
  us_oregon_tilth: `${baseUrl}/us_oregon_tilth.png`,
  // nz_swnz,
  // nz_biogro,
  // nz_asurequality,
};
export default function CertificationsIcons({ product: data, style }) {
  const product = useProduct(data);
  const certifications = [
    product.isCertifiedOrganic && {
      certificationCode: 'ORGANIC',
      certificationName: 'Certified Organic',
    },
    product.isBiodynamic && {
      certificationCode: 'BIODYNAMIC',
      certificationName: 'Biodynamic',
    },
    product.isVegan && {
      certificationCode: 'VEGAN',
      certificationName: 'Vegan',
    },
    product.isVegetarian && {
      certificationCode: 'VEGETARIAN',
      certificationName: 'Vegetarian',
    },
    ...(product.localCertifications || []),
    ...(product.internationalCertifications || []),
  ].filter(Boolean);

  const certificationsToRender =
    certifications?.length > 5
      ? certifications?.slice(0, 4).concat([
          {
            certificationCode: 'EXTRA',
          },
        ])
      : certifications;

  return (
    <Flex style={{ flexWrap: 'wrap' }}>
      {certificationsToRender?.map(
        ({ certificationName, certificationCode }, index) => {
          if (certificationImages[certificationCode])
            return (
              <BaseImage
                key={`${certificationCode}_${index}`}
                src={certificationImages[certificationCode]}
                style={{
                  height: 50,
                  marginRight: 12,
                }}
              />
            );
          return (
            <Box
              key={`${certificationCode}_${index}`}
              style={{ marginRight: 12 }}
            >
              {certificationCode === 'EXTRA' ? (
                <CircleIcon
                  value={`+ ${certifications.length - 4}`}
                  label={'more'}
                />
              ) : (
                <Box
                  style={{
                    backgroundColor: '#ffffff',
                    border: '1px solid, #0000000',
                    height: 50,
                    width: 50,
                    borderRadius: 25,
                    position: 'relative',
                  }}
                >
                  <Flex
                    style={{
                      flexDirection: 'column',
                      height: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      position: 'absolute',
                      left: 2,
                      right: 2,
                    }}
                  >
                    <BaseText
                      style={{
                        fontSize: 8,
                      }}
                    >
                      {certificationName}
                    </BaseText>
                  </Flex>
                </Box>
              )}
            </Box>
          );
        }
      )}
    </Flex>
  );
}
